
import { KudoBadge, ReactionType } from "../types";

export const ROOT_SUPER_ADMIN_EMAILS = [
  'chaitanya.yadav@gmail.com'
];

export const LANGUAGES = [
  { code: 'af', label: 'Afrikaans' },
  { code: 'sq', label: 'Albanian (Shqip)' },
  { code: 'am', label: 'Amharic (አማርኛ)' },
  { code: 'ar', label: 'Arabic (العربية)' },
  { code: 'hy', label: 'Armenian (Հայերեն)' },
  { code: 'as', label: 'Assamese (অসমীয়া)' },
  { code: 'az', label: 'Azerbaijani (Azərbaycan dili)' },
  { code: 'eu', label: 'Basque (Euskara)' },
  { code: 'be', label: 'Belarusian (беларуская мова)' },
  { code: 'bn', label: 'Bengali (বাংলা)' },
  { code: 'bs', label: 'Bosnian (Bosanski jezik)' },
  { code: 'bg', label: 'Bulgarian (български език)' },
  { code: 'my', label: 'Burmese (ဗမာစာ)' },
  { code: 'ca', label: 'Catalan (Català)' },
  { code: 'zh-CN', label: 'Chinese (Simplified, 普通话)' },
  { code: 'zh-TW', label: 'Chinese (Traditional, 繁體中文)' },
  { code: 'hr', label: 'Croatian (Hrvatski jezik)' },
  { code: 'cs', label: 'Czech (Čeština)' },
  { code: 'da', label: 'Danish (Dansk)' },
  { code: 'nl', label: 'Dutch (Nederlands)' },
  { code: 'en', label: 'English' },
  { code: 'et', label: 'Estonian (Eesti keel)' },
  { code: 'fil', label: 'Filipino' },
  { code: 'fi', label: 'Finnish (Suomi)' },
  { code: 'fr', label: 'French (Français)' },
  { code: 'gl', label: 'Galician (Galego)' },
  { code: 'ka', label: 'Georgian (ქართული)' },
  { code: 'de', label: 'German (Deutsch)' },
  { code: 'el', label: 'Greek (Ελληνικά)' },
  { code: 'gu', label: 'Gujarati (ગુજરાતી)' },
  { code: 'ht', label: 'Haitian Creole (Kreyòl ayisyen)' },
  { code: 'ha', label: 'Hausa' },
  { code: 'he', label: 'Hebrew (עִבְרִית)' },
  { code: 'hi', label: 'Hindi (हिन्दी)' },
  { code: 'hu', label: 'Hungarian (Magyar)' },
  { code: 'is', label: 'Icelandic (Íslenska)' },
  { code: 'ig', label: 'Igbo' },
  { code: 'id', label: 'Indonesian (Bahasa Indonesia)' },
  { code: 'ga', label: 'Irish (Gaeilge)' },
  { code: 'it', label: 'Italian (Italiano)' },
  { code: 'ja', label: 'Japanese (日本語)' },
  { code: 'jv', label: 'Javanese (Basa Jawa)' },
  { code: 'kn', label: 'Kannada (ಕನ್ನಡ)' },
  { code: 'ks', label: 'Kashmiri (कश्मीरी / كشميري)' },
  { code: 'kk', label: 'Kazakh (Қазақ тілі)' },
  { code: 'km', label: 'Khmer (ខ្ែរ)' },
  { code: 'rw', label: 'Kinyarwanda' },
  { code: 'ko', label: 'Korean (한국어)' },
  { code: 'ku', label: 'Kurdish (Kurdî)' },
  { code: 'ky', label: 'Kyrgyz (Кыргызча)' },
  { code: 'lo', label: 'Lao (ພາສາລາວ)' },
  { code: 'la', label: 'Latin (Latine)' },
  { code: 'lv', label: 'Latvian (Latviešu valoda)' },
  { code: 'lt', label: 'Lithuanian (Lietuvių kalba)' },
  { code: 'lb', label: 'Luxembourgish (Lëtzebuergesch)' },
  { code: 'mk', label: 'Macedonian (македонски јазик)' },
  { code: 'mg', label: 'Malagasy' },
  { code: 'ms', label: 'Malay (Bahasa Melayu)' },
  { code: 'ml', label: 'Malayalam (മലയാളം)' },
  { code: 'mt', label: 'Maltese (Malti)' },
  { code: 'mi', label: 'Maori (Te Reo Māori)' },
  { code: 'mr', label: 'Marathi (मराठी)' },
  { code: 'mn', label: 'Mongolian (Монгол)' },
  { code: 'ne', label: 'Nepali (नेपाली)' },
  { code: 'no', label: 'Norwegian (Norsk)' },
  { code: 'or', label: 'Odia (ଓଡ଼ିଆ)' },
  { code: 'ps', label: 'Pashto (پښتو)' },
  { code: 'fa', label: 'Persian (فارسی)' },
  { code: 'pl', label: 'Polish (Polski)' },
  { code: 'pt', label: 'Portuguese (Português)' },
  { code: 'pa', label: 'Punjabi (ਪੰਜਾਬੀ)' },
  { code: 'ro', label: 'Romanian (Română)' },
  { code: 'ru', label: 'Russian (Русский)' },
  { code: 'sm', label: 'Samoan (Gagana fa\'a Samoa)' },
  { code: 'gd', label: 'Scots Gaelic (Gàidhlig)' },
  { code: 'sr', label: 'Serbian (српски језик)' },
  { code: 'st', label: 'Sesotho' },
  { code: 'sn', label: 'Shona' },
  { code: 'sd', label: 'Sindhi (सिन्धी / سنڌي)' },
  { code: 'si', label: 'Sinhala (සිංහල)' },
  { code: 'sk', label: 'Slovak (Slovenčina)' },
  { code: 'sl', label: 'Slovenian (Slovenščina)' },
  { code: 'so', label: 'Somali (Soomaaliga)' },
  { code: 'es', label: 'Spanish (Español)' },
  { code: 'su', label: 'Sundanese (Basa Sunda)' },
  { code: 'sw', label: 'Swahili (Kiswahili)' },
  { code: 'sv', label: 'Swedish (Svenska)' },
  { code: 'tg', label: 'Tajik (тоҷикӣ)' },
  { code: 'ta', label: 'Tamil (தமிழ்)' },
  { code: 'tt', label: 'Tatar (татар теле)' },
  { code: 'te', label: 'Telugu (తెలుగు)' },
  { code: 'th', label: 'Thai (ไทย)' },
  { code: 'tr', label: 'Turkish (Türkçe)' },
  { code: 'tk', label: 'Turkmen (Türkmençe)' },
  { code: 'uk', label: 'Ukrainian (українська мова)' },
  { code: 'ur', label: 'Urdu (اردو)' },
  { code: 'ug', label: 'Uyghur (ئۇيغۇرچە)' },
  { code: 'uz', label: 'Uzbek (Oʻzbekcha)' },
  { code: 'vi', label: 'Vietnamese (Tiếng Việt)' },
  { code: 'cy', label: 'Welsh (Cymraeg)' },
  { code: 'fy', label: 'Western Frisian (Frysk)' },
  { code: 'xh', label: 'Xhosa (isiXhosa)' },
  { code: 'yi', label: 'Yiddish (ייִדיש)' },
  { code: 'yo', label: 'Yoruba (Yorùbá)' },
  { code: 'zu', label: 'Zulu (isiZulu)' },
];

export const COUNTRIES_STATES: { name: string; states: string[] }[] = [
    { name: 'United States', states: ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'] },
    { name: 'India', states: ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal'] },
    { name: 'United Kingdom', states: ['England', 'Scotland', 'Wales', 'Northern Ireland'] },
    { name: 'Canada', states: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Nova Scotia', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan'] },
    { name: 'Australia', states: ['New South Wales', 'Victoria', 'Queensland', 'Western Australia', 'South Australia', 'Tasmania'] },
    { name: 'Germany', states: ['Baden-Württemberg', 'Bavaria', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hesse', 'Lower Saxony', 'Mecklenburg-Vorpommern', 'North Rhine-Westphalia', 'Rhineland-Palatinate', 'Saarland', 'Saxony', 'Saxony-Anhalt', 'Schleswig-Holstein', 'Thuringia'] },
    { name: 'France', states: ['Auvergne-Rhône-Alpes', 'Bourgogne-Franche-Comté', 'Brittany', 'Centre-Val de Loire', 'Corsica', 'Grand Est', 'Hauts-de-France', 'Île-de-France', 'Normandy', 'Nouvelle-Aquitaine', 'Occitanie', "Pays de la Loire", "Provence-Alpes-Côte d'Azur"] },
    { name: 'Japan', states: ['Hokkaido', 'Tohoku', 'Kanto', 'Chubu', 'Kansai', 'Chugoku', 'Shikoku', 'Kyushu'] }, // Using regions as prefectures are too many
];

export const COUNTRY_CODES = [
    { name: 'United States', code: '+1', flag: '🇺🇸', minLen: 10, maxLen: 10, iso: 'US' },
    { name: 'India', code: '+91', flag: '🇮🇳', minLen: 10, maxLen: 10, iso: 'IN' },
    { name: 'United Kingdom', code: '+44', flag: '🇬🇧', minLen: 10, maxLen: 11, iso: 'GB' },
    { name: 'Canada', code: '+1', flag: '🇨🇦', minLen: 10, maxLen: 10, iso: 'CA' },
    { name: 'Australia', code: '+61', flag: '🇦🇺', minLen: 9, maxLen: 9, iso: 'AU' },
    { name: 'Germany', code: '+49', flag: '🇩🇪', minLen: 10, maxLen: 11, iso: 'DE' },
    { name: 'France', code: '+33', flag: '🇫🇷', minLen: 9, maxLen: 9, iso: 'FR' },
    { name: 'Japan', code: '+81', flag: '🇯🇵', minLen: 10, maxLen: 11, iso: 'JP' },
];

export const KUDO_BADGES: KudoBadge[] = [
  // Academic
  { id: 'hard-worker', name: 'Hard Worker', category: 'academic', icon: 'construction' },
  { id: 'problem-solver', name: 'Problem Solver', category: 'academic', icon: 'psychology_alt' },
  { id: 'curious-mind', name: 'Curious Mind', category: 'academic', icon: 'emoji_objects' },
  // Behavioral
  { id: 'great-focus', name: 'Great Focus', category: 'behavioral', icon: 'center_focus_strong' },
  { id: 'ready-to-learn', name: 'Ready to Learn', category: 'behavioral', icon: 'school' },
  { id: 'perseverance-power', name: 'Perseverance Power', category: 'behavioral', icon: 'filter_hdr' },
  { id: 'growth-mindset', name: 'Growth Mindset', category: 'behavioral', icon: 'trending_up' },
  // Character
  { id: 'kindness-captain', name: 'Kindness Captain', category: 'character', icon: 'volunteer_activism' },
  { id: 'team-player', name: 'Team Player', category: 'character', icon: 'groups' },
  { id: 'helping-hand', name: 'Helping Hand', category: 'character', icon: 'handshake' },
  { id: 'honesty-hero', name: 'Honesty Hero', category: 'character', icon: 'verified' },
  // Communication
  { id: 'clear-communicator', name: 'Clear Communicator', category: 'communication', icon: 'record_voice_over' },
  { id: 'active-listener', name: 'Active Listener', category: 'communication', icon: 'spatial_audio_off' },
  // Community
  { id: 'respectful-leader', name: 'Respectful Leader', category: 'community', icon: 'health_and_safety' },
  { id: 'school-pride', name: 'School Pride', category: 'community', icon: 'apartment' },
  { id: 'climate-champion', name: 'Climate Champion', category: 'community', icon: 'eco' },
  { id: 'inclusion-advocate', name: 'Inclusion Advocate', category: 'community', icon: 'diversity_3' },
  // Arts & Creativity
  { id: 'creative-thinker', name: 'Creative Thinker', category: 'arts_creativity', icon: 'brush' },
  { id: 'artistic-talent', name: 'Artistic Talent', category: 'arts_creativity', icon: 'palette' },
  { id: 'musical-maestro', name: 'Musical Maestro', category: 'arts_creativity', icon: 'music_note' },
  { id: 'stage-star', name: 'Stage Star', category: 'arts_creativity', icon: 'theater_comedy' },
  // Sports
  { id: 'sportsmanship-star', name: 'Sportsmanship Star', category: 'sports', icon: 'emoji_events' },
  { id: 'energy-and-effort', name: 'Energy & Effort', category: 'sports', icon: 'directions_run' },
  { id: 'team-captain', name: 'Team Captain', category: 'sports', icon: 'shield' },
  // Brain Power & Independent Thinking (More Brain, Less AI)
  { id: 'brain-bronze', name: 'Bronze • 100% Brain Power (No AI)', category: 'brain_power', icon: 'psychology' },
  { id: 'brain-silver', name: 'Silver • 3-Day Pure Brain (0 AI)', category: 'brain_power', icon: 'military_tech' },
  { id: 'brain-gold', name: 'Gold • 7-Day Pure Brain (0 AI)', category: 'brain_power', icon: 'workspace_premium' },
  { id: 'brain-platinum', name: 'Platinum • 30-Day Pure Brain (0 AI)', category: 'brain_power', icon: 'diamond' },
  { id: 'brain-mindful-explorer', name: 'Smart AI User • More Brain, Less AI', category: 'brain_power', icon: 'emoji_objects' },
];

export const TEACHER_KUDO_BADGES: KudoBadge[] = [
    { id: 'inspiring-mentor', name: 'Inspiring Mentor', category: 'teaching', icon: 'lightbulb_circle' },
    { id: 'super-supporter', name: 'Super Supporter', category: 'teaching', icon: 'volunteer_activism' },
    { id: 'communication-star', name: 'Communication Star', category: 'teaching', icon: 'chat_bubble' },
    { id: 'subject-wizard', name: 'Subject Wizard', category: 'teaching', icon: 'auto_awesome' },
    { id: 'patient-guide', name: 'Patient Guide', category: 'teaching', icon: 'accessibility_new' },
    { id: 'going-above-beyond', name: 'Above & Beyond', category: 'teaching', icon: 'rocket_launch' },
];

export const KUDO_CATEGORY_COLORS: Record<KudoBadge['category'], { text: string; border: string; hex: string; }> = {
    academic: { text: 'text-blue-500', border: 'border-blue-400', hex: '#3b82f6' },
    behavioral: { text: 'text-green-500', border: 'border-green-400', hex: '#22c55e' },
    character: { text: 'text-pink-500', border: 'border-pink-400', hex: '#ec4899' },
    communication: { text: 'text-teal-500', border: 'border-teal-400', hex: '#14b8a6' },
    community: { text: 'text-purple-500', border: 'border-purple-400', hex: '#a855f7' },
    arts_creativity: { text: 'text-rose-500', border: 'border-rose-400', hex: '#f43f5e' },
    sports: { text: 'text-orange-500', border: 'border-orange-400', hex: '#f97316' },
    teaching: { text: 'text-indigo-600', border: 'border-indigo-500', hex: '#4f46e5' },
    brain_power: { text: 'text-amber-600', border: 'border-amber-500', hex: '#d97706' },
};

export const PRINCIPAL_AWARD_COLOR = {
    text: 'text-amber-500',
    border: 'border-amber-500',
    hex: '#f59e0b'
};

export const REACTIONS: { id: ReactionType; name: string; icon: string }[] = [
    { id: 'star', name: 'Great Work', icon: 'star' },
    { id: 'thumbs_up', name: 'Thumbs Up', icon: 'thumb_up' },
    { id: 'bright_idea', name: 'Bright Idea', icon: 'lightbulb' },
    { id: 'heart', name: 'Loved It', icon: 'favorite' },
];
